import { useEffect, useState } from "react";
import { fetchManifests, type ManifestRecord } from "@/api/agent-control";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

export function ManifestHistoryTab() {
  const [manifests, setManifests] = useState<ManifestRecord[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchManifests()
      .then(setManifests)
      .catch((err) => setError(err instanceof Error ? err.message : "Failed to load manifests"))
      .finally(() => setLoading(false));
  }, []);

  if (error) {
    return (
      <div className="rounded-lg border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-400 m-4">
        {error}
      </div>
    );
  }

  if (loading) {
    return <div className="p-4 text-sm text-muted-foreground">Loading manifests...</div>;
  }

  return (
    <div className="space-y-4 p-4">
      <h3 className="text-lg font-semibold">Manifest History</h3>
      {manifests.length === 0 ? (
        <p className="text-sm text-muted-foreground">No manifests issued yet.</p>
      ) : (
        <div className="overflow-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>ID</TableHead>
                <TableHead>Kind</TableHead>
                <TableHead>Signing Key</TableHead>
                <TableHead>Counter</TableHead>
                <TableHead>Created</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {manifests.map((m) => (
                <TableRow key={m.manifest_id}>
                  <TableCell className="font-mono text-xs">
                    {m.manifest_id.slice(0, 8)}…
                  </TableCell>
                  <TableCell>
                    <span
                      className={`inline-block rounded px-2 py-0.5 text-xs font-medium ${
                        m.kind === "binary_attestation"
                          ? "bg-blue-500/20 text-blue-400"
                          : "bg-green-500/20 text-green-400"
                      }`}
                    >
                      {m.kind === "binary_attestation" ? "attestation" : "directive"}
                    </span>
                  </TableCell>
                  <TableCell className="font-mono text-xs text-muted-foreground">
                    {m.signing_key_id}
                  </TableCell>
                  <TableCell className="text-sm">
                    {m.monotonic_counter ?? "—"}
                  </TableCell>
                  <TableCell className="text-sm text-muted-foreground">
                    {new Date(m.created_at).toLocaleString()}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
}
